<template>
  <b-row class="m-0">
    <b-col md="6" sm="12" v-if="period_context_loaded" class="text-base pr-2 pb-4 pl-2">
      <b-container fluid style="height: auto; min-height: 245px" class="white-box">
        <b-row align-h="center" class="mt-2 mr-0 mb-4">
          Receita
        </b-row>



        <b-row class="receipt-justify m-0 mb-4">
        <b-col md='12' lg='12' class="text-14 mb-3">
        <b-row align-v="start" class="receipt-justify">
         <a class="custom-link text-left display-flex-span" :href="url_order_paid_orders + selectedPeriod" target="_blank">
          <span class="text-30">{{ total_order_paid }} <b class="text-14" style="vertical-align: middle;">({{ total_paid_orders_count }} pagos)</b></span>
          </a>
          </b-row>
        </b-col>
        </b-row>
        <b-row>
          <b-col md='12' lg='4' class="text-14 mb-3">
            <b-row align-v="start" class="receipt-justify">
            <div :class="'bullet-box mr-2 mt-1  gb'"></div>
            <a class="custom-link text-left display-flex-span" :href="url_order_current_period + selectedPeriod" target="_blank">
              <span>{{ total_bucket }}&nbsp;</span>
              <span class="text-12">(total de pedidos: {{ total_orders_count }})</span>
            </a>
            </b-row>

          </b-col>
          <b-col v-for="(obj, i) in PaymentsInfoObject_1" :key="'obj-1-' + i" lg="4" md="12" class="text-14 mb-3">
            <b-row align-v="start" class="receipt-justify">
              <div :class="'bullet-box mr-2 mt-1 ' + obj.bg"></div>
              <a class="custom-link text-left display-flex-span" :href="obj.url + selectedPeriod" target="_blank">
                <span>{{ obj.info }}&nbsp;</span>
                <span class="text-12">({{ obj.count }} {{ obj.label }})</span>
              </a>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
    </b-col>
    <b-col v-else md="6" sm="12" class="pr-2 pb-4 pl-2">
      <loader-box height="192px"/>
    </b-col>

    <b-col md="6" sm="12" v-if="period_context_loaded" class="text-base pr-2 pb-4 pl-2">
      <b-container fluid style="height: auto; min-height: 245px" class="white-box">
        <b-row class="mt-2 mr-0 mb-4 ml-0">
          Pedidos por método:
        </b-row>

        <b-row class="m-0">
          <b-col md="3" sm="12" v-for="(obj, index) in PaymentsInfoObject_2" :key="'obj-2-' + index" class="pl-0 mb-3">
            <b-row class="m-0 mb-2">
              <b-col md sm="2" cols="3" style="max-width: fit-content;" class="pl-0 text-left">
                <img :src="require(`@/assets/${obj.img}`)" alt="img">
              </b-col>
              <b-col class="line-height-1 margin-methods">
                <b-row class="text-14">{{ obj.info }}</b-row>
                <b-row class="text-12">
                  <a class="custom-link" :href="getMethodUrl(obj)" target="_blank">{{ obj.url_label }}</a>
                </b-row>
              </b-col>
            </b-row>
            <b-row v-for="(item, i) in obj.array" :key="'obj-2-' + i" class="align-items-center text-14 m-0 mb-2">
              <div :class="'bullet-box ' + item.bg"></div>
              <a class="custom-link" :href="getMethodItemUrl(obj, item)" target="_blank">{{ item.info }}</a>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
    </b-col>
    <b-col v-else md="6" sm="12" class="pr-2 pb-4 pl-2">
      <loader-box height="192px"/>
    </b-col>
  </b-row>
</template>

<script>
import LoaderBox from '@/components/LoaderBox.vue'

export default {
  components: {
    LoaderBox
  },
  computed: {
    period_context_loaded() { return this.$store.getters.period_context_loaded },
    orderPeriodSelectedIndex() { return this.$store.getters.orderPeriodSelectedIndex },
    total_bucket () { return this.$store.getters.total_bucket },
    total_orders_count () { return this.$store.getters.total_orders_count },
    total_order_paid() { return this.$store.getters.total_order_paid },
    total_paid_orders_count() { return this.$store.getters.total_paid_orders_count },
    url_order_paid_orders() { return this.$store.getters.url_order_paid_orders },
    url_order_current_period () { return this.$store.getters.url_order_current_period },
    PaymentsInfoObject_1() { return this.$store.getters.PaymentsInfoObject_1 },
    PaymentsInfoObject_2() { return this.$store.getters.PaymentsInfoObject_2 },

    selectedPeriod() {
      switch (this.orderPeriodSelectedIndex) {
        case 0:
          return '&date_period=1'
        case 1:
          return '&date_period=2'
        case 2:
          return '&date_period=3'
        case 3:
          return '&date_period=4'
        case 4:
          return '&date_period=6'
        case 5:
          return '&date_period=7'
        case 6:
          return 'date_period=8'
      }
      return ''
    }
  },
  methods: {
    getMethodUrl(obj) {
      // URL customizada apenas para o meio de pagamento Pix
      if (obj && obj.url_label === 'Pix') {
        const rawUrl = obj.url || '';

        try {
          // Usa a URL vinda do backend apenas para obter domínio + path
          const parsed = new URL(rawUrl, window.location.origin);
          const base = parsed.origin + parsed.pathname;

          // Anexa apenas os novos parâmetros desejados
          return base + '?q=&date_choice=1&date_period=&datepicker_date_range_start=&datepicker_date_range_end=&date_range=&single_date=&arquivado=0&custom_filter_marketplace_channel=&custom_filter_customer_id=&order_value=&custom_filter_product_id=&custom_filter_category_id=&custom_filter_department_id=&salepartner_filter=&custom_filter_city_id=&orders_per_campaign=&shipper_name=&tracking_code=&metodo_pagamento__forma_pagamento__exact=9&custom_filter_grupos_cliente=&invoice_number=&invoice_access_key=';
        } catch (e) {
          // Fallback: se não conseguir parsear, mantém o comportamento antigo
          return rawUrl ? rawUrl + this.selectedPeriod : '';
        }
      }

      // Demais meios de pagamento continuam usando a URL original + período selecionado
      return (obj && obj.url) ? obj.url + this.selectedPeriod : '';
    },
    getMethodItemUrl(obj, item) {
      // Itens internos (pagos/abertos/cancelados) continuam com o comportamento atual
      return (item && item.url) ? item.url + this.selectedPeriod : '';
    }
  }
}
</script>

<style scoped>
  @media only screen and (min-width: 768px) {
    .receipt-justify {
      justify-content: center;
    }
    .break-label-card {
      width: 100%;
      display: inline-block;
    }
    .margin-methods {
      margin-bottom: 1.25rem !important;
    }
  }

  @media only screen and (max-width: 768px) {
    .receipt-justify {
      margin-left: 0.25rem !important;
    }
  }

  @media only screen and (min-width: 992px) {
    .display-flex-span {
      display: flex;
      flex-direction: column;
    }
  }

  @media only screen and (max-width: 992px) {
    .display-flex-span {
      display: flex;
      flex-direction: row !important;
    }
  }
</style>
